// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PDoubleLeftOutlinedSvg from "@fishx/icons-svg/es/asn/PDoubleLeftOutlined";
import FishxIcon from '../components/FishxIcon';

var PDoubleLeftOutlined = function PDoubleLeftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PDoubleLeftOutlinedSvg
  }));
};

PDoubleLeftOutlined.displayName = 'PDoubleLeftOutlined';
export default React.forwardRef(PDoubleLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PDoubleLeftOutlined.js
// module id = 3333
// module chunks = 0